import * as PIXI from 'pixi.js';
import { ITestShootResult } from 'js/bubbleCore/handlers/testShoot';
import { PoolGroup } from 'framework/utils/PoolGroup';
import { spacePositionToPxPosition } from 'js/bubbleCore/view/utils/spacePositionToPxPosition';
import { IHexPixelSize } from 'js/bubbleCore/view/types';
import { IShooterData } from 'js/bubbleCore/types';
import { getColorForBubble } from 'js/bubbleCore/view/bubbles/getColorForBubble';
import { Lerper } from 'framework/utils/Lerper';
import { Range } from 'framework/utils/Range';

export class ShooterPointerView extends PIXI.Container {
  private readonly alphaLerper: Lerper;
  private readonly poolGroup: PoolGroup<PIXI.Sprite>;
  private readonly hexPixelSize: IHexPixelSize;
  private readonly model: IShooterData;

  constructor(hexPixelSize: IHexPixelSize, model: IShooterData) {
    super();
    this.model = model;
    this.hexPixelSize = hexPixelSize;
    this.poolGroup = PoolGroup.createSpritePool({
      anchor: 0.5,
      scale: 0.3,
      alpha: 0.8,
      parent: this,
    });

    this.alphaLerper = new Lerper({
      initValue: 0.2,
      lerp: 0.2,
      snap: 0.01,
      autoUpdate: true,
      range: new Range(0, 1),
    });
    this.alphaLerper.signals.onValueUpdate.add((value) => this.alpha = value);
    this.alphaLerper.signals.onUpdate.add(([currentValue, targetValue]) => {
      this.alphaLerper.setTarget(targetValue - 0.1);
    });
  }

  public updateView(result: ITestShootResult): void {
    this.alphaLerper.setTarget(1);

    if (this.children.length > result.positions.length) {
      this.children
        .slice(result.positions.length)
        .forEach((child: PIXI.Sprite) => this.poolGroup.release(child))
    }

    result.positions.forEach(({x, y}, index) => {
      const child = (
        this.children[index] || this.poolGroup.getInstance()
      ) as PIXI.Sprite;
      child.texture = PIXI.Texture.from('0_bubble_grey');
      child.tint = getColorForBubble(this.model.bubblesQueue[0]);
      spacePositionToPxPosition(
        x, y, this.hexPixelSize, child.position as PIXI.Point
      );
    });
  }
}